import React, { useState, useEffect } from "react";
import "./ScreenBlocker.css";

const ScreenSizeBlocker = ({ children }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 740);

  useEffect(() => {
    const handleResize = () => setIsSmallScreen(window.innerWidth < 740);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isSmallScreen) {
    return (
      <div className="screen-blocker-container">
        {/* Floating Backgrounds */}
        <div className="floating-bg floating-bg-1"></div>
        <div className="floating-bg floating-bg-2"></div>
        <div className="floating-bg floating-bg-3"></div>

        {/* Glassmorphic Message Box */}
        <div className="screen-blocker-message">
          <div className="screen-blocker-header">
            <h2>Unsupported Screen</h2>
            <p>This platform works only on desktops and laptops.</p>
          </div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default ScreenSizeBlocker;
